import React from 'react';
import { Box, BoxProps, SxProps } from '@mui/material';
import { useStacklineTheme } from '@stackline/ui';

interface SlPillProps extends BoxProps {
  selected?: boolean;
}

/**
 * An outlined pill that can be used for filtering a set based on multiple choices.
 */
export function SlPill({ children, sx, selected, ...rest }: SlPillProps) {
  const theme = useStacklineTheme();

  const selectedSx: SxProps = {
    color: 'white',
    border: '1px solid transparent',
    backgroundColor: theme.colors.primary
  };

  const defaultSx: SxProps = {
    color: theme.colors.primary,
    backgroundColor: 'white',
    border: `1px solid ${theme.colors.primaryGray}`
  };
  const mergedSx = {
    ...{
      display: 'flex',
      alignItems: 'center',
      height: '32px',
      paddingX: '20px',
      paddingY: '6px',
      fontSize: '14px',
      fontWeight: 500,
      borderRadius: '20px',
      cursor: 'pointer'
    },
    ...(selected ? selectedSx : defaultSx),
    ...sx
  };

  return (
    <Box sx={mergedSx} {...rest}>
      {children}
    </Box>
  );
}
